module.exports = "@media (max-width: 1024px) {\n  .secondary-show {\n    display: block; }\n  .secondary-hide {\n    display: none; } }\n"